import { PRODUCT_BRAND } from './productBrand';

/**
 * Public community channels — WhatsApp/Telegram for human help;
 * X/Facebook for broadcast & follow.
 *
 * Set REACT_APP_COMMUNITY_* at build time (see .env.example).
 */

const trim = value => (typeof value === 'string' && value.trim() ? value.trim() : null);

/** E.164 digits only for wa.me (no +). Example: 18765551234 */
export const COMMUNITY_WHATSAPP_E164 = trim(process.env.REACT_APP_COMMUNITY_WHATSAPP);

/** Public invite or @handle URL, e.g. https://t.me/ShopperZuluExchange */
export const COMMUNITY_TELEGRAM_URL = trim(process.env.REACT_APP_COMMUNITY_TELEGRAM_URL);

/** https://x.com/yourhandle */
export const COMMUNITY_X_URL = trim(process.env.REACT_APP_COMMUNITY_X_URL);

/** https://facebook.com/yourpage */
export const COMMUNITY_FACEBOOK_URL = trim(process.env.REACT_APP_COMMUNITY_FACEBOOK_URL);

/** https://instagram.com/yourhandle */
export const COMMUNITY_INSTAGRAM_URL = trim(process.env.REACT_APP_COMMUNITY_INSTAGRAM_URL);

export const hasHelpChannels = () =>
  Boolean(COMMUNITY_WHATSAPP_E164 || COMMUNITY_TELEGRAM_URL);

export const hasSocialChannels = () =>
  Boolean(COMMUNITY_X_URL || COMMUNITY_FACEBOOK_URL || COMMUNITY_INSTAGRAM_URL);

export const hasAnyCommunityChannel = () => hasHelpChannels() || hasSocialChannels();

const brand = PRODUCT_BRAND.name;

/**
 * Pre-filled ask templates per app — keep short; moderators see app context.
 */
export const COMMUNITY_ASK_INTENTS = {
  general: `Hi ${brand} — I have a request that isn’t listed on the site.`,
  xchange: `Hi — I’m on xChange and need help with a swap that isn’t listed.`,
  xbuy: `Hi — I’m on Buy & Sell and looking for something that isn’t posted yet.`,
  xstays: `Hi — I’m on Rentals and need something that isn’t listed.`,
  xcourier: `Hi — I’m looking for a service provider and didn’t find a match.`,
  xproxy: `Hi — I need a payer, courier, or big move runner and didn’t find a match.`,
  xevents: `Hi — I have an event question or want to host something custom.`,
  landing: `Hi ${brand} — I came from the app home and need help from the community.`,
};

export default {
  COMMUNITY_WHATSAPP_E164,
  COMMUNITY_TELEGRAM_URL,
  COMMUNITY_X_URL,
  COMMUNITY_FACEBOOK_URL,
  COMMUNITY_INSTAGRAM_URL,
  hasHelpChannels,
  hasSocialChannels,
  COMMUNITY_ASK_INTENTS,
};
